import { EdgeRecordLegalAcceptanceRepository } from '@/modules/legal/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { RecordLegalAcceptance } from '@/modules/legal/use-cases'

export function makeRecordLegalAcceptance(): RecordLegalAcceptance {
  return new EdgeRecordLegalAcceptanceRepository(makeSupabaseEdgeHttpClient()).execute
}
